import { FileCode, FileJson, FileText } from 'lucide-react';
import React from 'react';
import styled from 'styled-components';
import { FileType } from '../types';

interface FileTypeIconProps {
  fileType: FileType;
}

let IconBase = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
`;

let FileTypeIcon: React.FC<FileTypeIconProps> = ({ fileType }) => {
  switch (fileType) {
    case FileType.JAVASCRIPT:
      return (
        <IconBase color="#facc15">
          <FileCode size={16} />
        </IconBase>
      );
    case FileType.TYPESCRIPT:
      return (
        <IconBase color="#60a5fa">
          <FileCode size={16} />
        </IconBase>
      );
    case FileType.PYTHON:
      return (
        <IconBase color="#34d399">
          <FileCode size={16} />
        </IconBase>
      );
    case FileType.JSON:
      return (
        <IconBase color="#fb923c">
          <FileJson size={16} />
        </IconBase>
      );
    case FileType.HTML:
      return (
        <IconBase color="#f472b6">
          <FileText size={16} />
        </IconBase>
      );
    default:
      return (
        <IconBase color="#9ca3af">
          <FileText size={16} />
        </IconBase>
      );
  }
};

export default FileTypeIcon;
